import(/* webpackMode: "eager" */ "/home/interim/frontend/app/about/partners/page.tsx");
